import { Image } from 'antd'
import BaseConfig from 'general/constants/DomainConfig'
import { useHostname } from 'general/context/HostnameContext'
import { env } from 'general/utils/env'
import Utils from 'general/utils/Utils'
import useProjectBranding from 'hooks/useProjectBranding'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

function GuestHeader() {
  // MARK --- Params: ---
  const { t } = useTranslation()
  const { logo, secondLogo } = useProjectBranding()
  // MARK --- Functions: ---
  function handleNavigation(path) {
    window.open(path)
  }
  const hostname = useHostname()

  return (
    <div
      className="d-flex flex-row justify-content-between align-items-center px-md-12"
      style={{
        boxShadow: '0 2px 5px 0 rgb(0 0 0 / 26%)',
        backgroundColor: '#f0f0f0',
      }}
    >
      <div
        className={Utils.cn(
          'container-xl d-flex flex-row align-items-center',
          ['TULUC', 'SONPHAT'].includes(env.PROJECT_TYPE)
            ? 'justify-content-center'
            : 'justify-content-between',
        )}
      >
        <Image preview={false} className="h-50px" src={logo} alt="logo" />
        {/* {['TULUC', 'SONPHAT'].includes(env.PROJECT_TYPE) ? null : ( */}
        <ul
          className="text-uppercase font-weight-bolder overflow-hidden d-none d-lg-block m-0"
          style={{
            listStyleType: 'none',
            color: '#2567b2',
          }}
        >
          {BaseConfig[hostname]?.menubar.map((item) => (
            <li
              className="d-inline mr-4 cursor-pointer"
              onClick={() => handleNavigation(item.link)}
            >
              {t(`${item.translateText}`)}
            </li>
          ))}
          {/* <li
              className="d-inline ml-4 cursor-pointer"
              onClick={() => handleNavigation('https://vietinvoice.vn/tai-ve')}
            >
              {t('Download')}
            </li> */}
        </ul>
        {secondLogo && (
          <Image
            preview={false}
            className="h-50px"
            src={secondLogo}
            alt="logo"
          />
        )}
        {/* )} */}
        {BaseConfig[hostname]?.menubar.length > 0 && (
          <Dropdown className="d-lg-none">
            <Dropdown.Toggle variant="" id="dropdown-basic">
              <i className="fas fa-bars text-dark-75"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {BaseConfig[hostname]?.menubar.map((item) => {
                return (
                  <Dropdown.Item
                    className="font-weight-bolder"
                    onClick={() => handleNavigation(item.link)}
                  >
                    {t(`${item.translateText}`)}
                  </Dropdown.Item>
                )
              })}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
  )
}

export default GuestHeader
